import { useCallback, useEffect, useState } from 'react';

export type Tema = 'claro' | 'oscuro';

const CLAVE = 'betstock:tema';

/** Lo que hay guardado, o el default. El default es CLARO y no "lo que diga el sistema":
 *  esto se usa de día en una oficina y la mitad de las máquinas de Windows están en
 *  oscuro por defecto sin que nadie lo haya elegido. */
export function temaGuardado(): Tema {
  try {
    const v = localStorage.getItem(CLAVE);
    if (v === 'claro' || v === 'oscuro') return v;
  } catch {
    // Modo privado o cookies bloqueadas: se sigue con el default, no se rompe nada.
  }
  return 'claro';
}

export function aplicarTema(tema: Tema) {
  document.documentElement.classList.toggle('dark', tema === 'oscuro');
  // La barra del navegador en móvil acompaña al fondo real de la app.
  document
    .querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', tema === 'oscuro' ? '#0F1115' : '#EEF1F5');
}

export function useTema() {
  const [tema, setTema] = useState<Tema>(temaGuardado);

  useEffect(() => {
    aplicarTema(tema);
    try {
      localStorage.setItem(CLAVE, tema);
    } catch {
      // Sin persistencia el tema igual se aplica; se pierde recién al recargar.
    }
  }, [tema]);

  const alternar = useCallback(() => setTema((t) => (t === 'claro' ? 'oscuro' : 'claro')), []);
  return { tema, setTema, alternar };
}
